import { encode as base64_encode } from "base-64";

import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class VehicleOdometerStore {
  vehicleOdometerVehicles = [];
  loading = false;
  total = 0;
  rootStore;
  fileUploadUrl = "/vehicleOdoMeter/uploadExcel";

  constructor(rootStore) {
    makeObservable(this, {
      vehicleOdometerVehicles: observable,
      loading: observable,
      total: observable,
      loadData: action,
      exportExcel: action,
      addData: action,
      addOdometerByExcel: action,
      fileUploadUrl: observable,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit, vehicleId }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      offset: offset,
      limit: limit,
    };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=odometer&a=getOdometerDetails",
    //     "postData=" + base64Input
    //   );

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicleOdoMeter/getOdometerDetails", { params: postData });

    this.vehicleOdometerVehicles = response?.data?.data?.odometer;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async addData(vehicleOdometer) {
    var postData = vehicleOdometer;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=odometer&a=saveOdometer", "postData=" + base64Input);

    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("vehicleOdoMeter/saveOdoMeter", { vehicleOdometer });
    return response;
  }

  async exportExcel(postData) {
    // window.location.href =
    //   baseURL +
    //   "index.php?c=odometer&a=sampleExcel&cid=" +
    //   getData.companyId +
    //   "&isadmin=" +
    //   getData.isadmin +
    //   "&userId=" +
    //   getData.userId +
    //   "&colList=" +
    //   getData.colList;

    try {
      var response = await postApi.getClient("NodeCoreUrl").post(
        "vehicleOdoMeter/exportSampleData",
        { postData: postData },
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Vehicle Odometer Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async addOdometerByExcel(excelFile) {
    try {
      this.excelLoadig = true;
      var postData = excelFile;
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient("NodeCoreUrl")
        .post("vehicleOdoMeter/importOdometerData", {
          postData: postData,
        });
      // var response = await postApi
      //   .getClient()
      //   .post("index.php?c=odometer&a=odometerexcel", "postData=" + base64Input);
      this.excelLoadig = false;
      return response.data;
    } catch (error) {
      this.excelLoadig = false;
      return error?.response?.data;
    }
  }
}

export default VehicleOdometerStore;
